import styled from "styled-components"

const Infos = styled.h3`
  color: ${(props) => props.theme.a_color_gradients.a_dark};
`

export { Infos }
